const getTenantConfig = () => {
  const env = process.env.REACT_APP_ENV || "demo";
  
  const getTenantApiKeys = () => {
    switch (env) {
      case "local":
        return {
          tenantCoreApiKey: process.env.REACT_APP_TENANT_CORE_API_KEY,
          tenantPrimeApiKey: process.env.REACT_APP_TENANT_PRIME_API_KEY, 
          tenantOtpApiKey: process.env.REACT_APP_TENANT_OTP_API_KEY,
        };
      case "dev":
        return {
          tenantCoreApiKey: process.env.REACT_APP_TENANT_CORE_API_KEY,
          tenantPrimeApiKey: process.env.REACT_APP_TENANT_PRIME_API_KEY, 
          tenantOtpApiKey: process.env.REACT_APP_TENANT_OTP_API_KEY,
        };
      case "demo":
      case "production":
        return {
          tenantCoreApiKey: process.env.REACT_APP_TENANT_CORE_API_KEY_DEMO_PROD,
          tenantPrimeApiKey: process.env.REACT_APP_TENANT_PRIME_API_KEY_DEMO_PROD, 
          tenantOtpApiKey: process.env.REACT_APP_TENANT_OTP_DEMO_API_KEY,
        };
      default:
        return {
          tenantCoreApiKey: process.env.REACT_APP_TENANT_CORE_API_KEY_DEMO_PROD,
          tenantPrimeApiKey: process.env.REACT_APP_TENANT_PRIME_API_KEY_DEMO_PROD,
          tenantOtpApiKey: process.env.REACT_APP_TENANT_OTP_DEMO_API_KEY,
        };
    }
  };

  const tenantApiKeys = getTenantApiKeys();

  return {
    TENANT_CORE_API_KEY: tenantApiKeys.tenantCoreApiKey,
    TENANT_PRIME_API_KEY: tenantApiKeys.tenantPrimeApiKey,
    TENANT_OTP_API_KEY: tenantApiKeys.tenantOtpApiKey,
  };
};

const tenantConfig = getTenantConfig();
export const TENANT_CORE_API_KEY = tenantConfig.TENANT_CORE_API_KEY;
export const TENANT_PRIME_API_KEY = tenantConfig.TENANT_PRIME_API_KEY;
export const TENANT_OTP_API_KEY = tenantConfig.TENANT_OTP_API_KEY;